import React, { useEffect, useState } from "react";
import {  useNavigate } from "react-router-dom";
import {  FiShare2, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { BiBookmark } from "react-icons/bi";
import { useRef } from "react";
import Header from "../components/headerfooter/Header";
import axios from "axios";
import { IMAGE_URL, PROMPT_VIDEO_URL, REACT_APP_API_PORT} from "../Api";
import { getDecryptedData } from "../config/crypto";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import { FaCrown } from "react-icons/fa";
import moment from "moment";
import MobileFooter from "../components/MobileFooter";
import { FaBookmark } from "react-icons/fa";
import CategoryNavbar from "../components/headerfooter/CategoryNavbar";
import { Helmet } from "react-helmet";
import JoinBottomBarPrompts from '../JoinBottomBarPrompts';
import UnlockPromptsPopup from "../components/UnlockPromptsPopup";
const MyPrompt = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [categoryData, setcategoryData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [limit, setLimit] = useState(45); 
    const [showFilters, setShowFilters] = useState(false);
    const [isPremiumUser, setIsPremiumUser] = useState(false);
    const [showUnlockPopup, setShowUnlockPopup] = useState(false);

    // const [showFilters, setShowFilters] = useState(() => {
    //     const saved = localStorage.getItem("showFilters");
    //     return saved === null ? true : JSON.parse(saved);
    //     });

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [copiedId, setCopiedId] = useState(null);
    const [query, setQuery] = useState("");
    const [search, setSearch] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [category, setcategory] = useState("");
    const [tags, settags] = useState("");
    const [meta, setMeta] = useState([]);

    const [viewMode, setViewMode] = useState(window.innerWidth < 768 ? "list" : "grid");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const popupActiveRef = useRef(false);

const popupTimerRef = useRef(null);
const popupIntervalRef = useRef(null);

useEffect(() => {
  if (isPremiumUser) return;

 const startPopupCycle = () => {
  // ⏱️ First popup after 35 seconds
  popupTimerRef.current = setTimeout(() => {
    setShowUnlockPopup(true);

    // 🔁 Then show popup every 5 minutes
    popupIntervalRef.current = setInterval(() => {
      setShowUnlockPopup(true);
    }, 5 * 60 * 1000); // 5 minutes

  }, 35 * 1000);
};

  startPopupCycle();

  return () => {
    if (popupTimerRef.current) {
      clearTimeout(popupTimerRef.current);
      popupTimerRef.current = null;
    }
  };
}, [isPremiumUser]);






            useEffect(() => {
                const handleResize = () => {
                    setWindowWidth(window.innerWidth);
                };

                window.addEventListener("resize", handleResize);
                return () => window.removeEventListener("resize", handleResize);
            }, []);



    useEffect(() => {
        if (windowWidth < 768 && viewMode !== "list") {
            setViewMode("list");
        } else if (windowWidth >= 768 && viewMode !== "grid") {
            setViewMode("grid");
        }
    }, [windowWidth]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, []);

    const checkPremiumStatus = async () => {
    try {
        const token = getDecryptedData("token");
        if (!token) return;

        const res = await axios.get(
        `${REACT_APP_API_PORT}user/frontend/user/check-premium`,
        {
            headers: {
            "x-access-token": token,
            },
        }
        );

        if (res.data?.isPremiumUser) {
        setIsPremiumUser(true);
        } else {
        setIsPremiumUser(false);
        }
    } catch (err) {
        console.error("Premium check failed", err);
        setIsPremiumUser(false);
    }
    };


    const getData = async (page) => {
        try {
            setIsLoading(true);
            const user = getDecryptedData("user");
            let userId = "";
            if (user) {
                userId = user._id;
            }
            const res = await axios.get(
                `${REACT_APP_API_PORT}user/homepage/all_prompts?limit=${limit}&page=${page}&userId=${userId}&search=${search}&duration=${selectedCategory}&category=${category}&tags=${tags !== "Premium" ? tags : ""}&payment_type=${tags === "Premium" ? "Premium" : ""}`
            );
            setIsLoading(false);
            setData(res.data.data);
            setTotalPages(res.data.pagination?.totalPages);
            setTotalItems(res.data.pagination?.totalItems);
            
            if (selectedItem) {
                const matchedItem = res.data.data.find((item) => item._id === selectedItem._id);
                if (matchedItem) {
                    setSelectedItem(matchedItem);
                }
            }
        } catch (err) {
            setIsLoading(false);
            console.log(err);
        }
    };


    const getCategoryData = async (page) => {
        try {
            setIsLoading(true);

            const res = await axios.get(
                `${REACT_APP_API_PORT}user/homepage/activepromptcategory`
            );
            setIsLoading(false);
            setcategoryData(res.data.data);
        } catch (err) {
            setIsLoading(false);
            console.log(err);
        }
    };

    const fetchMetaData = async () => {
        try {
            setIsLoading(true);
            const res = await axios.get(
                `${REACT_APP_API_PORT}user/homepage/page-seo-details/Prompts Page`
            );
            if (res.data.status) {
                setMeta(res.data.data)

            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getCategoryData()
        fetchMetaData()
        checkPremiumStatus();
    }, [])

    useEffect(()=>{
  getData(currentPage);
},[currentPage,search,tags,category,selectedCategory])

   



    const handleLoadMore = () => {
        setLimit((prevLimit) => prevLimit + 8);
    };

    const openSidebar = (item) => {
        setSelectedItem(item);
        setIsSidebarOpen(true);
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
        setSelectedItem(null);
    };

    const [openFaq, setOpenFaq] = useState(null);

    const handleFaqToggle = (index) => {
        setOpenFaq((prev) => (prev === index ? null : index));
    };

    const handleToolNavigate = async (toolId) => {
        const user = getDecryptedData("user");
        if (!user) {
            navigate(`/login`);
        }
        if (user) {
            try {
                setIsLoading(true);
                const token = getDecryptedData("token");
                const res = await axios.post(
                    `${REACT_APP_API_PORT}user/frontend/save-prompt`,
                    {
                        prompt_id: toolId,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    }
                );
                setIsLoading(false);
                if (res.data.status) {
                    getData();
                }
            } catch (err) {
                setIsLoading(false);
                if (err.response.data.status === false) {
                    toast.error(err.response.data.message);
                }
            }
        }
    };



    const isNewCard = (createdAt) => {
        return moment(createdAt).isSameOrAfter(moment().subtract(1, 'day'));
    };

    const isOlderCard = (createdAt) => {
        return moment(createdAt).isBefore(moment().subtract(1, 'day'));
    };

    const stripHtml = (html="") => html.replace(/<[^>]+>/g,"");

    return (
        <>
            <Helmet>
                <title>{meta?.meta_title}</title>
                <meta name="description" content={meta?.meta_description} />
                <meta name="keywords" content={meta?.meta_keywords} />
            </Helmet>
            {/* <WhatsAppChatButton /> */}
            <Loader isLoading={isLoading} />

            <Header isSearch={true} setQuery={setQuery} setSearch={setSearch} search={search} query={query} />

            <section className="bg-background-back1 min-h-screen overflow-hidden pt-24 lg:pt-32">
                {/* <CourseSlider search={search} /> */}

                <div className="container max-w-[80rem] mx-auto px-4 pt- mb-10 pb-16">
                

                   {/* ALWAYS VISIBLE REFINE BAR */}
            <div className="max-w-[80rem] mx-auto px-4 mt-4">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-[15px] md:text-[22px] font-semibold text-gray-100">
                Prompts Library
                </h2>

                <button
                onClick={() => setShowFilters((prev) => !prev)}
                className="
                    flex items-center gap-2
                    px-4 py-2 rounded-lg
                    text-sm font-semibold
                    bg-white/5 border border-white/10 hover:bg-white/20
                    transition text-white
                "
                >
                Filters
                {showFilters ? (
                    <FiChevronUp className="text-lg" />
                ) : (
                    <FiChevronDown className="text-lg" />
                )}
                </button>
            </div>
            </div>


                    {showFilters && (
                // <div className="container max-w-[80rem] mx-auto px-4 mb-6">
                    <div
                className="
                    relative z-20
                    rounded-2xl 
                    bg-white/5 border border-white/10
                    p-4 sm:p-6
                    shadow-[0_0_0_1px_rgba(255,255,255,0.08)]
                    mb-6 sm:mb-10
                "
                >


                    {/* SEARCH */}
                    <input
                        type="text"
                        placeholder="Search prompts..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                       className="
                        w-full px-4 py-3 mb-4 rounded-full
                        bg-white/10
                        text-white placeholder-gray-400
                        border border-white/20
                        focus:outline-none focus:ring-2 focus:ring-customBlue
                        focus:border-customBlue
                    "
                    />

                    {/* YOUR FILTERS */}
                    <CategoryNavbar
                        categoryData={categoryData}
                        selectedCategory={selectedCategory}
                        setSelectedCategory={setSelectedCategory}
                        category={category}
                        setcategory={setcategory}
                        totalItems={totalItems}
                        tags={tags}
                        settags={settags}
                    />
                    </div>
                // </div>
                )}






                    {(data && data?.length > 0) && (
                        <div
                    className={
                        viewMode === "grid"
                        ? "grid grid-cols-1 mt-6 sm:mt-8 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-10 mb-8"
                        : "flex flex-col gap-4 md:gap-6 mb-5"
                    }
                    >
                           {data.map((item, index) => (
  <div
    key={item._id}
     className="
        relative z-10
        group overflow-hidden rounded-2xl
        border border-white/10
        bg-transparent
        shadow-lg
        transition-all duration-300 ease-out
        hover:border-customBlue hover:bg-[#0f0f0f]
        hover:-translate-y-1
        cursor-pointer
        h-[420px]
    "

  >
    {/* IMAGE / VIDEO */}
    {item?.prompt_type === "Image Prompt" && (
      <img
      loading="lazy"
        decoding="async"
        fetchpriority="low"
        src={item.image ? IMAGE_URL + item.image : "/just-launch-default.png"}
        className="absolute inset-0 w-full h-full object-cover"
        onError={(e) => (e.target.src = "/just-launch-default.png")}
      />
    )}

    {item?.prompt_type === "Video Prompt" && item.video && (
      <video
        src={PROMPT_VIDEO_URL + item.video}
        autoPlay
        muted
        loop
        className="absolute inset-0 w-full h-full object-cover"
      />
    )}

    {/* OVERLAY */}
    {/* <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div> */}
    <div className="absolute inset-x-0 bottom-0 h-[55%] bg-gradient-to-t from-black/55 via-black/25 to-transparent"></div>



    {item.payment_type === "Premium" && (
  <div
    className="absolute top-4 right-4 bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
               text-white text-xs font-bold px-3 py-1 rounded-full z-10
               flex items-center gap-1 pointer-events-none"
  >
    <FaCrown className="text-sm" />
  </div>
)}


    {/* TITLE */}
    <div className="absolute top-4 left-4 max-w-[220px] z-10">
      <span className="bg-black/50 px-3 py-1 rounded-full text-xs uppercase line-clamp-1 text-white font-semibold">
    {item.title}
    </span>

    </div>

    {/* CONTENT */}
    <div className="absolute bottom-0 p-5 w-full z-10">
        {(item.payment_type !== "Premium" || isPremiumUser) && (
        <p className="text-white/90 text-sm line-clamp-3 mb-4">
            {stripHtml(item.short_description)}
        </p>
        )}



      <div className="flex justify-between items-center w-full">

  {/* LEFT SIDE */}
  <div>
   {item.payment_type === "Premium" && !isPremiumUser ? (
  // ❌ Non-premium user
  <button
  onClick={(e) => {
    e.stopPropagation();
    window.open(
      "https://learn.nextfutureai.in/web/checkout/685f8b74380b713204ab0841?couponcode=LEARN50&purchaseNow=true",
      "_blank",
      "noopener,noreferrer"
    );
  }}
  className="px-4 py-2 rounded-lg text-xs font-semibold text-white
    bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
    hover:opacity-90 transition flex items-center gap-2"
>
  <FaCrown className="text-sm" />
  Unlock Premium
</button>



) : (
  // ✅ Premium user OR free prompt
  <button
    onClick={(e) => {
      e.stopPropagation();
      const prompts = [];
      if (item.image_prompt) prompts.push(item.image_prompt);
      if (item.video_prompt) prompts.push(item.video_prompt);
      navigator.clipboard.writeText(prompts.join("\n"));
      setCopiedId(item._id);
      setTimeout(() => setCopiedId(null), 1500);
    }}
    className={`px-4 py-2 rounded-lg text-xs font-semibold text-white transition
      ${
        copiedId === item._id
          ? "bg-gradient-to-r from-orange-500 via-pink-500 to-purple-500"
          : "bg-white/20 hover:bg-white/30"
      }`}
  >
    {copiedId === item._id ? "✔ Copied" : "Copy Prompt"}
  </button>
)}


    
  </div>

  
<div className="flex items-center gap-2">

  {/* TAG (near share icon) */}
  {item?.tags?.length > 0 && (
    <button
      className="
        px-3 py-2
        rounded-full
        bg-white/10 hover:bg-white/20
        transition
        flex items-center justify-center
      "
      title="Prompt By"
    >
      <span className="text-[10px] font-semibold uppercase text-white">
        {item.tags[0]}
      </span>
    </button>
  )}


  {/* SHARE */}
  <button
    onClick={(e) => {
      e.stopPropagation();
      const prompts = [];
      if (item.image_prompt) prompts.push(item.image_prompt);
      if (item.video_prompt) prompts.push(item.video_prompt);

      if (navigator.share) {
        navigator.share({
          title: item.title,
          text: prompts.join("\n"),
        });
      }
    }}
    className="bg-white/10 hover:bg-white/20 p-2 rounded-full"
    title="Share Prompt"
  >
    <FiShare2 className="text-white text-sm" />
  </button>

  {/* SAVE */}
  <button
    onClick={(e) => {
      e.stopPropagation();
      handleToolNavigate(item._id);
    }}
    className="bg-white/10 hover:bg-white/20 p-2 rounded-full"
    title="Save Prompt"
  >
    {item?.is_saved ? (
      <FaBookmark className="text-white text-sm" />
    ) : (
      <BiBookmark className="text-white text-sm" />
    )}
  </button>

</div>


</div>



    </div>
  </div>
))}

                        </div>
                    )}


                    {!isLoading && data?.length === 0 && (
                        <div className="flex items-center justify-center h-64 bg-gray-900 rounded-2xl shadow-md">
                            <div className="text-center">
                                <svg
                                    className="mx-auto mb-4 h-12 w-12 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M9.75 9.75h.008v.008H9.75V9.75zM14.25 9.75h.008v.008h-.008V9.75zM12 14.25c-1.5 0-2.25 1.5-2.25 1.5h4.5s-.75-1.5-2.25-1.5z"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                                <h3 className="text-lg font-semibold text-gray-100">Data Not Found</h3>
                                <p className="text-sm text-gray-400 mt-1">We couldn't find any matching results.</p>
                            </div>
                        </div>
                    )}

                    {totalPages > 1 && (
                    <div className="w-full flex justify-center items-center gap-4 mt-10 mb-5 pb-10 md:pb-0">

                        {/* PREV */}
                        <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((p) => p - 1)}
                        className={`px-5 py-2 rounded-lg text-white transition
                            ${
                            currentPage === 1
                                ? "bg-white/20 text-black cursor-not-allowed"
                                : "bg-white/20 hover:bg-white/30"
                            }`}
                        >
                        ⬅ Prev
                        </button>

                        {/* PAGE INFO */}
                        <span className="text-gray-300 text-xs lg:text-sm">
                        Page {currentPage} of {totalPages}
                        </span>

                        {/* NEXT */}
                        <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((p) => p + 1)}
                        className={`px-5 py-2 rounded-lg text-white transition
                            ${
                            currentPage === totalPages
                                ? "bg-black cursor-not-allowed"
                                : "bg-white/10 hover:bg-white/20"
                            }`}
                        >
                        Next ➡
                        </button>

                    </div>
                    )}


                </div>
            </section>



            <JoinBottomBarPrompts />
            <MobileFooter /> 
            <style jsx>{`
                .image-container {
                    overflow: hidden;
                    position: relative;
                    width: 100%;
                }
                .image-container.list-image {
                    width: 5rem; /* Match w-20 (80px) */
                    height: 6.4rem; /* Match h-[6.4rem] */
                }
                .image-container.grid-image {
                    height: 10rem; /* Default height for grid view */
                    margin-top: 0.75rem; /* Match mt-3 */
                }
                @media (min-width: 640px) {
                    .image-container.grid-image {
                        height: 12rem; /* Larger height for sm screens */
                    }
                }
                @media (min-width: 768px) {
                    .image-container.grid-image {
                        height: 14rem; /* Larger height for md screens */
                    }
                }
                @media (min-width: 1024px) {
                    .image-container.grid-image {
                        height: 16rem; /* Larger height for lg screens */
                    }
                }
                .zoom-image {
                    transition: transform 0.3s ease;
                    position: relative;
                    z-index: 1;
                    width: 100%;
                    height: 100%;
                }
                .image-container:hover .zoom-image {
                    transform: scale(1.1);
                }
                .crown-icon {
                    position: absolute;
                    top: 20px;
                    right: 8px;
                    background: rgba(0, 0, 0, 0.6);
                    border-radius: 10%;
                    padding: 4px;
                    z-index: 2;
                }
                .crown-icon svg {
                    width: 16px;
                    height: 16px;
                }
                .image-container.list-image .crown-icon svg {
                    width: 14px;
                    height: 14px;
                }
            `}</style>
        </>
    );
};



export default MyPrompt;